import actions from './actions';

const initState = {
    productInfo: {},
    products   : {
        data: []
    },
    loading : false,
    productDeleted : false
};

export default function fetchProductsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_PRODUCTS_REQUESTED:
        case actions.SEARCH_PRODUCT_REQUESTED:
            return {
                ...state,
                products   : {
                    data: []
                },
                productInfo: {},
                loading : true
            };
        case actions.FETCH_PRODUCTS_SUCCEEDED:
        case actions.SEARCH_PRODUCT_SUCCEEDED:
            return {
                ...state,
                products    : action.products,
                loading     : false
            };
        case actions.FETCH_PRODUCTS_FAILED:
        case actions.SEARCH_PRODUCT_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.FETCH_PRODUCT_REQUESTED:
            return {
                ...state,
                productInfo: {},
                loading : true
            };
        case actions.FETCH_PRODUCT_SUCCEEDED:
            return {
                ...state,
                productInfo: action.product,
                loading     : false
            };
        case actions.FETCH_PRODUCT_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.DELETE_PRODUCT_REQUESTED:
            return {
                ...state,
                loading : true,
                productDeleted: false
            };
        case actions.DELETE_PRODUCT_SUCCEEDED:
            return {
                ...state,
                loading     : false,
                productDeleted : true
            };
        case actions.DELETE_PRODUCT_FAILED:
            return {
                ...state,
                loading : false,
                productDeleted: false
            };
        default:
            return state;
    }
}
